import { documentApi } from "@api/documents";
import { QueryBuildHelper } from "@components/SearchBar/QueryBuildHelper";
import {
  invenioConfig,
  setReactSearchKitInitialQueryState,
  setReactSearchKitDefaultSortingOnEmptyQueryString,
  setReactSearchKitUrlHandler,
} from "@config";
import history from "@history";
import { SearchControls } from "@modules/SearchControls/SearchControls";
import { SearchControlsOverridesMap } from "@modules/SearchControls/SearchControlsOverrides";
import SearchFooter from "@modules/SearchControls/SearchFooter";
import { BackOfficeRoutes } from "@routes/urls";
import React, { Component } from "react";
import { OverridableContext } from "react-overridable";
import SearchAggregationsCards from "@modules/SearchControls/SearchAggregationsCards";
import {
  EmptyResults,
  Error,
  InvenioSearchApi,
  ReactSearchKit,
  ResultsLoader,
  SearchBar,
} from "react-searchkit";
import {
  Button,
  Container,
  Grid,
  Header,
  Icon,
  Label,
} from "semantic-ui-react";
import ClearFiltersButton from "../../../modules/SearchControls/ClearFiltersButton";
import SessionFiltersPersistence from "@modules/SearchControls/SessionFiltersPersistence";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import DocumentLabelsResultsGrid from "./DocumentLabelsResultsGrid";

export default class DocumentLabelsSearchComponent extends Component {
  modelName = "DOCUMENTS";

  searchApi = new InvenioSearchApi({
    axios: {
      url: documentApi.searchBaseURL,
      withCredentials: true,
    },
  });

  render() {
    const { selectedDocuments } = this.props;
    const helperFields = [
      {
        name: "author",
        field: "authors.full_name",
        defaultValue: '"Doe, John"',
      },
      {
        name: "created",
        field: "_created",
      },
      {
        name: "published",
        field: "imprint.date",
      },
    ];

    const initialState = setReactSearchKitInitialQueryState(this.modelName);
    const defaultSortingOnEmptyQueryString =
      setReactSearchKitDefaultSortingOnEmptyQueryString(this.modelName);
    const urlHandler = setReactSearchKitUrlHandler(this.modelName);

    return (
      <>
        <Header as="h2" className="document-labels-header">
          Document Labels Generation
        </Header>
        <OverridableContext.Provider
          value={{
            ...SearchControlsOverridesMap,
          }}
        >
          <ReactSearchKit
            searchApi={this.searchApi}
            history={history}
            urlHandlerApi={urlHandler}
            initialQueryState={initialState}
            defaultSortingOnEmptyQueryString={defaultSortingOnEmptyQueryString}
          >
            <>
              <SessionFiltersPersistence moduleIdentifier="documents" />
              <Container fluid className="spaced">
                <Grid>
                  <Grid.Row verticalAlign="middle">
                    <Grid.Column width={13}>
                      <SearchBar
                        placeholder="Search for documents..."
                        {...invenioConfig.APP.SEARCH_BAR_PROPS}
                      />
                      <QueryBuildHelper fields={helperFields} />
                    </Grid.Column>
                    <Grid.Column width={3} textAlign="right">
                      <Button
                        as={Link}
                        to={BackOfficeRoutes.documentLabelsSelected}
                        color="blue"
                        icon
                        labelPosition="left"
                        className="labels-cart-button"
                        style={{ marginTop: 0 }}
                      >
                        <Icon name="tags" />
                        Selected Documents
                        <Label color="red" floating>
                          {selectedDocuments.length}
                        </Label>
                      </Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
              <Container fluid className="bo-search-body">
                <Grid>
                  <Grid.Row columns={2}>
                    <ResultsLoader>
                      <Grid.Column width={3} className="search-aggregations">
                        <Grid.Column width={16}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "1rem",
                            }}
                          >
                            <Header
                              as="h4"
                              content="Filter by"
                              style={{ margin: 0 }}
                            />
                            <ClearFiltersButton module-identifier="loans" />
                          </div>
                        </Grid.Column>
                        <SearchAggregationsCards modelName={this.modelName} />
                      </Grid.Column>
                      <Grid.Column width={13}>
                        <EmptyResults />
                        <Error />
                        <SearchControls
                          modelName={this.modelName}
                          withLayoutSwitcher={false}
                        />
                        <DocumentLabelsResultsGrid
                          selectedDocuments={selectedDocuments}
                          addDocumentToSelection={
                            this.props.addDocumentToSelection
                          }
                          removeDocumentFromSelection={
                            this.props.removeDocumentFromSelection
                          }
                          updateDocumentInSelection={
                            this.props.updateDocumentInSelection
                          }
                        />
                        <SearchFooter />
                      </Grid.Column>
                    </ResultsLoader>
                  </Grid.Row>
                </Grid>
              </Container>
            </>
          </ReactSearchKit>
        </OverridableContext.Provider>
      </>
    );
  }
}

DocumentLabelsSearchComponent.propTypes = {
  selectedDocuments: PropTypes.array.isRequired,
  addDocumentToSelection: PropTypes.func.isRequired,
  removeDocumentFromSelection: PropTypes.func.isRequired,
  updateDocumentInSelection: PropTypes.func.isRequired,
};
